import React from "react";
import "../styles.css";
import MerchandiseDetailPage from "./MerchandiseDetailPage";


const Shop = () => (
  <div className="page-container">
    
    <MerchandiseDetailPage/>
  </div>
);

export default Shop;
